export { VcardTemplate } from "./VcardTemplate";
export { useVcardData } from "./hooks";
